import { render, staticRenderFns } from "./ODateTime.vue?vue&type=template&id=5051bb54&scoped=true&"
import script from "./ODateTime.vue?vue&type=script&lang=js&"
export * from "./ODateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051bb54",
  null
  
)

export default component.exports